var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99999 11.7554L3.68399 10.2714C3.39841 9.94932 3.35095 9.48066 3.56616 9.10789L4.84537 6.89213C5.06059 6.51937 5.49018 6.32615 5.91186 6.41243L7.85515 6.81006L9.14483 6.06543L9.77206 4.18377C9.90818 3.77543 10.2903 3.5 10.7207 3.5H13.2792C13.7097 3.5 14.0918 3.77543 14.2279 4.18377L14.8552 6.06543L16.1448 6.81006L18.0881 6.41243C18.5098 6.32615 18.9394 6.51937 19.1546 6.89213L20.4339 9.10785C20.6491 9.48062 20.6016 9.94929 20.316 10.2713L19 11.7554V13.2446L20.316 14.7286C20.6016 15.0507 20.649 15.5193 20.4338 15.8921L19.1546 18.1078C18.9394 18.4806 18.5098 18.6738 18.0881 18.5875L16.1447 18.1899L14.8551 18.9344L14.2279 20.8162C14.0918 21.2245 13.7097 21.5 13.2792 21.5H10.7208C10.2903 21.5 9.90819 21.2246 9.77207 20.8162L9.14483 18.9345L7.85521 18.1899L5.91185 18.5876C5.49017 18.6739 5.06058 18.4806 4.84537 18.1079L3.56613 15.8921C3.35092 15.5194 3.3984 15.0507 3.68399 14.7287L4.99999 13.2446V11.7554Z",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 3,
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqSettings);
export default __webpack_public_path__ + "static/media/faq-settings.50956f3a.svg";
export { ForwardRef as ReactComponent };